// @flow
import { connect } from 'react-redux';
import DualSpinnerBase from '../base';
import { getConfig } from '~/core/state/config/selectors';

const BLUE = { r: 69, g: 180, b: 255 };
const GREEN = { r: 66, g: 168, b: 118 };
const CELSIUS_MID_TEMP = 26;
const FAHRENHEIT_MID_TEMP = 78;

type RGB = { r: number, g: number, b: number };

const mapStateToProps = (
    state,
    { isSingleBGColorOnly, mode, minCool, maxCool, disabled }
): {
    aboveColor: null | RGB,
    belowColor: null | RGB,
    bgColor: RGB,
    disabled: boolean,
    interval: string,
    maxTemp: number,
    metric: string,
    midTemp: { C: number, F: number },
    minTemp: number,
    mode: string
} => {
    const metric = getConfig(state, 'products:cooling:metric');
    const maxTemp = maxCool || getConfig(state, 'products:cooling:maxTemp');
    const minTemp = minCool || getConfig(state, 'products:cooling:minTemp');
    const midTemp = { C: CELSIUS_MID_TEMP, F: FAHRENHEIT_MID_TEMP };

    const aboveColor = isSingleBGColorOnly ? null : GREEN;
    const belowColor = isSingleBGColorOnly ? null : BLUE;
    return {
        aboveColor,
        bgColor: BLUE,
        belowColor,
        interval: getConfig(state, 'products:cooling:interval'),
        maxTemp,
        metric,
        midTemp,
        minTemp,
        mode,
        disabled
    };
};

export default connect(mapStateToProps)(DualSpinnerBase);



// WEBPACK FOOTER //
// ./src/components/widgets/temperature-spinner/dual-color-range/cooling/index.js